import { useEffect, useState } from 'react';

const cardMinWidth = 230;
export default function useVideoWidth(inputRef: any): number {
  const [cardWidth, setCardWidth] = useState(cardMinWidth);
  useEffect(() => {
    const element = inputRef?.current;
    if (!element) return;
    const observer = new ResizeObserver(() => {
      const paddingLeft = parseInt(getComputedStyle(element).paddingLeft);
      const paddingRight = parseInt(getComputedStyle(element).paddingRight);
      const gap = parseInt(getComputedStyle(element).gap);
      const width = inputRef.current.offsetWidth - (paddingLeft + paddingRight);
      if (inputRef && inputRef.current) {
        const itemCount = Math.round(width / (cardMinWidth + gap / 2));
        setCardWidth((width - itemCount * gap) / itemCount);
      }
    });
    observer.observe(element);
    return () => {
      // Cleanup the observer by unobserving all elements
      observer.disconnect();
    };
  }, []);

  return cardWidth;
}
